import React, {Component} from "react";
import axios from 'axios';
import {Dropdown} from 'semantic-ui-react';

export default class EnvSelection extends Component {

    state = {
        options: []
    };


    componentDidMount() {
        axios.get("/api/envs").then(res => {
            if (res.status === 200 && res.data) {
                this.setState({options: res.data});
            }
        });
    }

    render() {

        const { options } = this.state;
        const { currentEnv, onChange } = this.props;

        return (
            <Dropdown
                placeholder={"Environment Selection"}
                fluid search selection
                options={options}
                defaultValue={currentEnv}
                onChange={onChange}
                data-it="env-dropdown"
            />
        )

    }


}
